var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlumbing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plumbing"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 14.46,
    y: 14,
    width: 35.1,
    height: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 94.4,
    y: 74.44,
    width: 15.6,
    height: 37.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M45.66,66V37.4H20.31V80.09a25.55,25.55,0,0,0,25.55,25.55H86.6V80.29H60A14.29,14.29,0,0,1,45.66,66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbing);
export default __webpack_public_path__ + "static/media/plumbing.0dea0593588df148c6b0a40a5da97d62.svg";
export { ForwardRef as ReactComponent };